import { render } from "./MyPagination.vue?vue&type=template&id=3867a548"
import script from "./MyPagination.vue?vue&type=script&lang=js"
export * from "./MyPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__